import __request__ from "routing/request";
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations/gcp/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getGCPRegions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.enterprise.integrations/gcp/regions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
